/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

export interface BankDetailsFormState {
  status: 'idle' | 'loading' | 'success' | 'error';
  banks: any,
  bankBranches: any,
  bankDetails: any;
  error: {
    isError: boolean,
    type: string | null,
    message: string | null
  }
}

// Initial State
const initialState: BankDetailsFormState = {
  status: 'idle',
  banks: [],
  bankBranches: [],
  bankDetails: {},
  error: {
    isError: false,
    type: null,
    message: '',
  },
};

export const bankDetailsFormSlice = createSlice({
  name: 'bankDetailsForm',
  initialState,
  reducers: {
    getBanks: (state) => {},
    getBankBranches: (state, action) => {},
    setBanks: (state, action) => {
      const data = action.payload?.sort((a: any, b: any) => {
        const textA = a.name.toUpperCase();
        const textB = b.name.toUpperCase();
        const t = (textA > textB) ? 1 : 0;
        return (textA < textB) ? -1 : t;
      });
      state.banks = data;
      state.status = 'idle';
    },
    setBankBranches: (state, action) => {
      const data = action.payload?.sort((a: any, b: any) => {
        const textA = a.ifsc.toUpperCase();
        const textB = b.ifsc.toUpperCase();
        const t = (textA > textB) ? 1 : 0;
        return (textA < textB) ? -1 : t;
      });
      state.bankBranches = data;
      state.status = 'idle';
    },
    setBankDetailsFormStatus: (state, action) => {
      state.status = action.payload;
    },
    saveBankAccountDetails: (state, action) => {},
    setBankAccountDetails: (state, action) => {
      state.bankDetails = action.payload;
      state.status = 'success';
    },
    setBankDetailsFormError: (state, action) => {
      state.error = action.payload;
      state.status = 'error';
    },
    clearBankDetailsFormError: (state) => {
      state.error = {
        isError: false,
        type: null,
        message: '',
      };
      state.status = 'idle';
    },
  },
});

// Actions
export const {
  getBanks, getBankBranches, setBanks, setBankBranches, saveBankAccountDetails,
  setBankDetailsFormStatus, setBankDetailsFormError, clearBankDetailsFormError,
  setBankAccountDetails,
} = bankDetailsFormSlice.actions;

// Slice Reducer
export default bankDetailsFormSlice.reducer;
